import routerOptions0 from "D:/workFile/taro-trip/node_modules/.pnpm/nuxt@3.12.4_@parcel+watcher@2.4.1_@types+node@22.5.1_eslint@8.57.0_ioredis@5.4.1_magicast@0.3_degpylqra7tzjng2yik37paszi/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}